<div style="height: 400px; width: 100%; background-color: yellow; align-content: center; text-align: center">
  {{ text }}
</div>
